<template>
  <div>
    <div
      v-if="!isLoadingKycVerificationData"
      class="kyc-status"
    >
      {{ $t('kyc.kyc_status') }}
      <span class="request-change">
        {{ $t('kyc.request_change') }}
      </span>
    </div>
    <div
      v-else
      class="kyc-status"
    >
      <b-skeleton
        width="200px"
        height="30px"
      />
    </div>
    <div class="section-white">
      <div class="columns">
        <div
          v-if="!isLoadingKycVerificationData"
          class="column is-one-fifth t-al-center"
        >
          <img src="/static/svg/kyc-request-change.svg">
        </div>
        <div
          v-else
          class="column is-one-fifth t-al-center"
        >
          <b-skeleton
            width="80px"
            height="80px"
            circle=""
          />
        </div>
        <div
          v-if="!isLoadingKycVerificationData"
          class="column"
        >
          <div class="kyc-status-title request-change">
            {{ $t('kyc.request_change_kulap_plus_title') }}
          </div>
          <div class="kyc-status-sub-title">
            {{ $t('kyc.request_change_kulap_plus_detail') }}
          </div>
          <a
            :href="kulapPlusUpdateKycLink"
            target="_blank"
            class="kyc-status-link"
          >
            {{ $t('kyc.request_change_kulap_plus_link_text') }}
          </a>
          <div class="kyc-status-sub-title">
            {{ $t('kyc.request_change_kulap_plus_footer') }}
          </div>
        </div>
        <div
          v-else
          class="column"
        >
          <b-skeleton
            height="25px"
            width="45%"
          />
          <b-skeleton height="25px"/>
        </div>
      </div>
      <hr>
      <!-- <EditKYCForm
        :form.sync="form"
        :countries="countries"
        :provinces-in-thailand="provincesInThailand"
        :occupation-list="occupationList"
        :business-list="businessList"
        :average-income-list="averageIncomeList"
        :nationality="nationality"
        :type-of-card="typeOfCard"
        :customer-type="customerType"
        :working-at-company-country="workingAtCompanyCountry"
        :origin-country="originCountry"
        :current-country="currentCountry"
        :org-country="orgCountry"
        :kyc-topics-list="kycTopicsList"
        :details="details"
      /> -->
    </div>
    <!-- <b-button
      :disabled="!details.length"
      :loading="isLoadingSubmitKyc"
      class="verification-again-btn"
      data-test="kyc-status-for-fix--verification-again-btn"
      @click="submitAgain"
    >
      {{ $t('buttons.verify_again') }}
    </b-button> -->
  </div>
</template>

<script>
import EditKYCForm from './EditKYCForm'
import { getKulapPlusURL } from '@/environments'

export default {
  name: 'KYCStatusForFix',
  inject: ['$validator'],
  components: { EditKYCForm },
  props: {
    nationality: {
      type: String,
      required: true
    },
    typeOfCard: {
      type: String,
      required: true
    },
    customerType: {
      type: String, // Personal || Organization
      required: true
    },
    workingAtCompanyCountry: {
      type: String, // Personal
      required: true
    },
    originCountry: {
      type: String,
      required: true
    },
    currentCountry: {
      type: String,
      required: true
    },
    orgCountry: {
      type: String,
      required: true
    },
    details: {
      type: Array,
      default: () => []
    },
    countries: {
      type: Array,
      default: () => []
    },
    provincesInThailand: {
      type: Array,
      default: () => []
    },
    occupationList: {
      type: Array,
      default: () => []
    },
    businessList: {
      type: Array,
      default: () => []
    },
    averageIncomeList: {
      type: Array,
      default: () => []
    },
    kycTopicsList: {
      type: Object,
      default: () => {}
    },
    isLoadingKycVerificationData: {
      type: Boolean,
      default: false
    },
    isLoadingSubmitKyc: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {}
    }
  },
  computed: {
    kulapPlusUpdateKycLink () {
      return `${getKulapPlusURL()}/kyc/request-change`
    }
  },
  methods: {
    async submitAgain () {
      this.$emit('submitFormAgain', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
.kyc-status {
  font-size: 19px;
  font-weight: bold;
  color: #000000;
  width: 100%;
  margin-bottom: 15px;
  padding: 20px;

  span {
    border-radius: 21px;
    border: solid 2px;
    font-size: 13px;
    font-weight: bold;
    padding: 10px 10px;
    margin-left: 15px;
  }
}
.verifying {
  color: #0559af;
  border-color: #0559af;
}
.request-change {
  color: #dc3731;
  border-color: #dc3731;
}
.approved {
  color: #43a047;
  border-color: #43a047;
}
.rejected {
  color: #dc3731;
  border-color: #dc3731;
}
.section-white {
  display: block;
  margin: 0 auto;
  padding: 50px;
  max-width: 1024px;
  width: calc(100% - 20px);
  border-radius: 3px;
  box-shadow: 0 0 6px -2px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
.t-al-center {
  text-align: center;
}
.kyc-status-title {
  font-family: Roboto;
  font-size: 21px;
  font-weight: bold;
}
.kyc-status-sub-title {
  margin-top: 10px;
}

.kyc-status-link {
  line-height: 50px;
}
.verification-again-btn {
  display: flex;
  justify-content: center;
  width: calc(100% - 20px);
  cursor: pointer;
  margin: 40px auto 80px;
  padding: 23px 14px;
  border-radius: 3px;
  border: unset;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  background-color: #50e3c2;
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  text-align: center;
  color: #ffffff;
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .section-white {
    width: calc(100% - 20px);
    padding: 30px 15px;
  }
  .kyc-status-sub-title {
    text-align: center;
  }
  .kyc-status-title {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SummaryOfKYC/components/KYCStatusForFix.vue